// import gsap from 'gsap';

if (document.querySelector('.first-sec__row')) {
  document.querySelectorAll('.first-sec__row').forEach((row) => {
    const track = row.querySelector('.first-sec__row-track');
    const contents = track.querySelectorAll('.first-sec__row-content');

    const maxChildren = Math.max(
      ...Array.from(contents).map((content) => content.children.length)
    );

    contents.forEach((content) => {
      const currentLen = content.children.length;
      const diff = maxChildren - currentLen;
      if (diff > 0) {
        const childrenArray = Array.from(content.children);
        for (let i = 0; i < diff; i++) {
          const randIndex = Math.floor(Math.random() * childrenArray.length);
          const clone = childrenArray[randIndex].cloneNode(true);
          content.appendChild(clone);
        }
      }
    });

    const originalContent = track.querySelector('.first-sec__row-content');
    for (let i = 0; i < 4; i++) {
      const clone = originalContent.cloneNode(true);
      track.appendChild(clone);
    }

    const totalWidth = originalContent.offsetWidth;

    gsap.set(track, { x: -window.innerWidth });

    gsap.to(track, {
      x: `${-1 * totalWidth}px`,
      duration: 80,
      ease: 'none',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth),
      },
    });
  });
}
